<template>
  <div v-if="showModal">
    <transition name="modal">
      <div class="modal-mask">
        <div
          class="modal-wrapper"
          @click.self="hideModal"
        >
          <div
            id="modalContainer"
            class="modal-container"
          >
            <div
              class="modal-close"
              @click="hideModal"
            />
            <div class="modal-header">
              <slot name="header" />
            </div>

            <div class="modal-body">
              <slot name="body">
                <component
                  :is="showComponent"
                  v-bind="props"
                />
              </slot>
            </div>

            <div class="modal-footer">
              <slot name="footer" />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import AccountPage from '@/components/AccountPage'
import SignIn from '@/components/Cards/SignIn'

export default {
	name: 'Modal',
	components: {
		AccountPage,
		SignIn
	},
	data () {
		return {}
	},
	computed: {
		showModal: function () {
			return this.$store.getters.modal['show']
		},
		showComponent: function () {
			return this.$store.getters.modal['component']
		},
		props: function () {
			return this.$store.getters.modal['props']
		}
	},
	mounted () {
		// show_modal in url
		if (this.getUrlParameter('showModal') === 'signIn') {
			let modalPayload = {
				'component': 'SignIn',
				'props': {}
			}
			this.$store.dispatch('showModal', modalPayload)
		}
	},
	methods: {
		getUrlParameter: function (name) {
			 
			name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
			var regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
			var results = regex.exec(location.search)
			return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
		},
		hideModal () {
			this.$store.dispatch('hideModal')
			this.$store.dispatch('clearAllAccountHistory')
			window.location.hash = ''
		}
	}
}
</script>

<style scoped></style>
